{
  "#MDE_ETIKETTENDRUCK": {
    "STEPS": {
      "PREISART": {
        "TITLE": "Preisart-Auswahl",
        "DESCRIPTION": "Bitte Preisart auswählen!"
      },
      "ETIKETTENART": {
        "TITLE": "Etikettenart",
        "DESCRIPTION": "Bitte Etikettenart auswählen!"
      }
    },
    "ERFASSUNG": {
      "ITEMS_IMPORTED": "{{count}} Artikel für den Etikettendruck übernommen",
      "ITEMS_IMPORT_SKIPPED": "{{count}} Artikel ohne Einheit übersprungen"
    },
    "DETAIL": {
      "SCAN_SAVED_TITLE": "Artikel gespeichert",
      "SCAN_SAVED_MESSAGE": "{{menge}} × {{artikel}}"
    }
  }
}
